import { HYPERION_API_DOMAIN } from "@/common/config";

export const BASE_URL = HYPERION_API_DOMAIN + "/hyperionapi";

// ENDPOINTS
export const ENDPOINT_CONFIG = BASE_URL + "/v1/config";
export const ENDPOINT_FEATURE_LOCK = BASE_URL + "/v1/featurelock";
export const ENDPOINT_WOD = BASE_URL + "/v1/wod";
export const ENDPOINT_WOD_MAP = BASE_URL + "/v1/map/wod";
export const ENDPOINT_WOD_CHARTS = BASE_URL + "/v1/chart/wod";
export const ENDPOINT_NEWS = BASE_URL + "/v2/news";
export const ENDPOINT_NEWS_MAP = BASE_URL + "/v2/map/news";
export const ENDPOINT_SOCIAL = BASE_URL + "/v2/tweets";
export const ENDPOINT_SOCIAL_MAP = BASE_URL + "/v2/tweets/geohash";
export const ENDPOINT_GRIDS = BASE_URL + "/v2/pulse";
export const ENDPOINT_GRIDS_COUNTRY = BASE_URL + "/v2/pulse/country";
export const ENDPOINT_GRIDS_DELTA = BASE_URL + "/v2/pulse/delta";
export const ENDPOINT_USER_PROFILE = BASE_URL + "/v3/user/profile";
export const ENDPOINT_USER_GROUP_MEMBERS = BASE_URL + "/v3/user/groups/members";
export const ENDPOINT_USER_GROUPS = BASE_URL + "/v2/user/groups";
export const ENDPOINT_USER_ACCEPT_WELCOME =
  BASE_URL + "/v2/user/accept-welcome";
export const ENDPOINT_AOIS = BASE_URL + "/v1/aois";
export const ENDPOINT_SENTIMENT = BASE_URL + "/v2/sentiment";
export const ENDPOINT_TRANSLATOR = BASE_URL + "/v1/translate";
export const ENDPOINT_ALERTS = BASE_URL + "/v3/alerts";
export const ENDPOINT_ALERT_UNSUBSCRIBE = BASE_URL + "/v3/alerts/unsubscribe";
export const ENDPOINT_ALERTED_DATA = BASE_URL + "/v3/alerts/data";
export const ENDPOINT_SEMANTIC = BASE_URL + "/v1/semantic";
export const ENDPOINT_CUSTOM_LAYERS = BASE_URL + "/v1/custom-layers";
export const ENDPOINT_HOTSPOTS = BASE_URL + "/v1/hotspots";
export const ENDPOINT_HOTSPOTS_TOPIC = BASE_URL + "/v1/hotspots/topic";
export const ENDPOINT_HOTSPOTS_TOPIC_TOP = BASE_URL + "/v1/hotspots/topic/top";
export const ENDPOINT_TOPICS = BASE_URL + "/v1/topics";
export const ENDPOINT_CLUSTER_LOCATION_CORRECTION =
  BASE_URL + "/v2/clusters/correction";
export const ENDPOINT_ARTICLE_LOCATION_CORRECTION =
  BASE_URL + "/v2/clusters/correction/article";
export const ENDPOINT_REGISTER_DEVICE =
  BASE_URL + "/v1/notifications/device/register";
export const ENDPOINT_UNREGISTER_DEVICE =
  BASE_URL + "/v1/notifications/device/unregister";

export const ENDPOINT_REPORTING_RISK_RATING_ALL =
  BASE_URL + "/v1/reporting/risk-ratings";
export const ENDPOINT_REPORTING_COUNTRY =
  BASE_URL + "/v1/reporting/country-report";
export const ENDPOINT_REPORTING_CUSTOM_COUNTRY =
  BASE_URL + "/v1/reporting/custom-country-report";
export const ENDPOINT_REPORTING_WATER = BASE_URL + "/v1/reporting/water-report";
export const ENDPOINT_REPORTING_CUSTOM_WATER =
  BASE_URL + "/v1/reporting/custom-water-report";
export const ENDPOINT_REPORTING_CITY = BASE_URL + "/v1/reporting/city-report";
export const ENDPOINT_REPORTING_CUSTOM_CITY =
  BASE_URL + "/v1/reporting/custom-city-report";
export const ENDPOINT_REPORTING_ANALYSIS =
  BASE_URL + "/v1/reporting/analysis-report";
export const ENDPOINT_REPORTING_ASSET = BASE_URL + "/v1/reporting/asset-report";

export const ENDPOINT_DASHBOARDS = BASE_URL + "/v1/dashboards";
export const ENDPOINT_SCRIBE = BASE_URL + "/v2/auto-summary";
export const ENDPOINT_TRAVEL_TRACKER_TRAVELERS =
  BASE_URL + "/v1/isos-traveler/travelers";
export const ENDPOINT_TRAVEL_TRACKER_PROFILE =
  BASE_URL + "/v1/isos-traveler/profile";
export const ENDPOINT_TRAVEL_TRACKER_PROFILES =
  BASE_URL + "/v1/isos-traveler/profiles";

// collaboration URLs
export const ENDPOINT_COLLABORATION_FOLDERS = BASE_URL + "/v1/collaboration";
export const ENDPOINT_COLLABORATION_EXPORT =
  BASE_URL + "/v1/collaboration/export";
export const ENDPOINT_COLLABORATION_SHARE =
  BASE_URL + "/v1/collaboration/share";
export const ENDPOINT_COLLABORATION_LINK = BASE_URL + "/v1/collaboration/link";

// notifications (savedsearch, tripwires)
export const ENDPOINT_NOTIFICATIONS = BASE_URL + "/v1/notifications";
export const ENDPOINT_NOTIFICATIONS_V2 =
  BASE_URL + "/v1/searches-notifications";

// saved search
export const ENDPOINT_SAVED_SEARCH = BASE_URL + "/v2/savedsearch";

// communication URLs
export const ENDPOINT_COMMUNICATION = BASE_URL + "/v1/mass-notifications";

// target URLs
export const ENDPOINT_TARGET =
  BASE_URL + "/v1/third-party-integrations/targets";
export const ENDPOINT_TARGET_TEST =
  BASE_URL + "/v1/third-party-integrations/targets/tests";

// assets URLs
export const ENDPOINT_ASSETS = BASE_URL + "/v1/assets";

// My Incidents URLS
export const ENDPOINT_MY_INCIDENTS = BASE_URL + "/v1/my-incidents";

// Power Outage
export const ENDPOINT_POWER_OUTAGE = BASE_URL + "/v1/power-outage/counties";

// Cyber
export const ENDPOINT_CYBER_PROFILE = ENDPOINT_WOD + "/cyber-profile";
export const ENDPOINT_CYBER_PROFILE_CONFIG =
  BASE_URL + "/v1/config/cyber-profile";

// Internal CR Urls
export const ENDPOINT_RISK_CATEGORIES = BASE_URL + "/v1/config/risk-categories";
export const ENDPOINT_RISK_RATING_CATEGORIES =
  BASE_URL + "/v1/config/risk-rating-categories";
export const ENDPOINT_EVACUATION_LEVELS =
  BASE_URL + "/v1/config/evacuation-levels";

// static URLs
export const STATIC_RESOURCES_PATH = "/hyperion-v2-static";

export const PLACES_IMAGE_URL = STATIC_RESOURCES_PATH + "/places";

export const AOIS_JSON_PATH = STATIC_RESOURCES_PATH + "/aois";
export const CITIES_JSON_URL = AOIS_JSON_PATH + "/cities.json";
export const COUNTRIES_JSON_URL = AOIS_JSON_PATH + "/countries.json";
export const COUNTIES_JSON_URL = AOIS_JSON_PATH + "/counties-low-res.json";
export const REGIONS_JSON_URL = AOIS_JSON_PATH + "/crRegions.json";

// digests
export const ENDPOINT_DIGESTS = BASE_URL + "/v1/digest";

// Global Issues
export const ENDPOINT_GLOBAL_ISSUES_CONFIG =
  BASE_URL + "/v1/config/global-issues";

// GRD Profile
export const ENDPOINT_GRD_PROFILE = ENDPOINT_WOD + "/grd-profile";

// Methodology
export const ENDPOINT_METHODOLOGY_CONFIG =
  BASE_URL + "/v1/config/methodologies";

// Calendar Events
export const ENDPOINT_CALENDAR_EVENTS_CONFIG =
  BASE_URL + "/v1/config/calendar-events";
export const ENDPOINT_CALENDAR_EVENTS = ENDPOINT_WOD + "/calendar-events";

// Tags
export const ENDPOINT_TAGS_CONFIG = BASE_URL + "/v1/config/tags";

// NLQ
export const NLQ_URL = BASE_URL + "/v1/nlq";

export const ENDPOINT_BREAKING_EVENTS = ENDPOINT_WOD + "/breaking-events";

// Embassy Countries
export const ENDPOINT_EMBASSY_COUNTRIES_CONFIG =
  BASE_URL + "/v1/config/embassies-countries";
